import _ from 'lodash';
import changeLogo from '../assets/msuitelogos/logo-change.svg';
import cultureLogo from '../assets/msuitelogos/logo-culture.svg';
import exitLogo from '../assets/msuitelogos/logo-exit.svg';
import myReportsLogo from '../assets/msuitelogos/logo-myReports.svg';
import riskLogo from '../assets/msuitelogos/logo-risk.svg';
import sparkLogo from '../assets/msuitelogos/logo-spark.svg';
import thriveLogo from '../assets/msuitelogos/logo-thrive.svg';
import { ExternalApplicationType, IExternalApplicationType, IExternalApplicationTypeVm } from '../models';

const addDisplayNameAndSequence = (appTypes: IExternalApplicationType[]) => {
	// Removing AppTypes we aren't using in SurveyBuilder
	_.remove(appTypes, (appType: IExternalApplicationType) => {
		switch (appType.externalApplicationType) {
			case ExternalApplicationType.mResearch:
			case ExternalApplicationType.m360:
			case ExternalApplicationType.Heat:
				return true;
		}
		return false;
	});

	// Adding in DisplayName and Sequence desired by SurveyBuilder
	let appTypeVms: IExternalApplicationTypeVm[] = [];

	_.forEach(appTypes, (appType: IExternalApplicationType) => {
		switch (appType.externalApplicationType) {
			case ExternalApplicationType.MyReports:
				appType.sequence = 1;
				appType.logo = myReportsLogo;
				break;
			case ExternalApplicationType.mThrive:
				appType.sequence = 2;
				appType.logo = thriveLogo;
				break;
			case ExternalApplicationType.mExit:
				appType.sequence = 3;
				appType.logo = exitLogo;
				break;
			case ExternalApplicationType.mSpark:
				appType.sequence = 4;
				appType.logo = sparkLogo;
				break;
			case ExternalApplicationType.mCulture:
				appType.sequence = 5;
				appType.logo = cultureLogo;
				break;
			case ExternalApplicationType.mRisk:
				appType.sequence = 6;
				appType.logo = riskLogo;
				break;
			case ExternalApplicationType.mChange:
				appType.sequence = 7;
				appType.logo = changeLogo;
				break;
		}

		appTypeVms.push(appType);
	});

	// Sorting by Sequence which is the order desired by SurveyBuilder
	appTypeVms = _.sortBy(appTypeVms, (a) => [a?.isDisabled, a?.sequence]);

	return appTypeVms;
};

export const ExternalApplicationTypeHelper = {
	addDisplayNameAndSequence,
};
